import React from 'react';

const GAMES = [
  {
    id: 'slots',
    icon: '🎰',
    title: 'Slot Machine',
    desc: 'Classic 3-reel slots — win up to 80× bet',
    tag: 'Up to 80×',
    color: '#7C3AED',
    bg: 'rgba(124,58,237,0.12)',
    border: 'rgba(124,58,237,0.3)',
  },
  {
    id: 'crash',
    icon: '🚀',
    title: 'Crash',
    desc: 'Rocket flies up — cash out before it crashes!',
    tag: 'Up to 1000×',
    color: '#F59E0B',
    bg: 'rgba(245,158,11,0.12)',
    border: 'rgba(245,158,11,0.3)',
  },
  {
    id: 'coinflip',
    icon: '🪙',
    title: 'Coin Flip',
    desc: 'Pick APE or BANANA — flip and win 1.9×!',
    tag: '50/50 odds',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.12)',
    border: 'rgba(16,185,129,0.3)',
  },
  {
    id: 'dice',
    icon: '🎲',
    title: 'Dice Roll',
    desc: 'Pick a number 1–6 and win 5.7× your bet!',
    tag: '5.7× payout',
    color: '#EF4444',
    bg: 'rgba(239,68,68,0.12)',
    border: 'rgba(239,68,68,0.3)',
  },
  {
    id: 'plinko',
    icon: '🎡',
    title: 'Plinko',
    desc: 'Drop the ball — land on up to 10× multiplier',
    tag: 'Up to 10×',
    color: '#A855F7',
    bg: 'rgba(168,85,247,0.12)',
    border: 'rgba(168,85,247,0.3)',
  },
  {
    id: 'hilo',
    icon: '🃏',
    title: 'HiLo Cards',
    desc: 'Guess higher 5 times — win up to 22.87×',
    tag: 'Up to 22.87×',
    color: '#06B6D4',
    bg: 'rgba(6,182,212,0.12)',
    border: 'rgba(6,182,212,0.3)',
  },
  {
    id: 'mines',
    icon: '💣',
    title: 'Mines',
    desc: 'Avoid explosions, reveal safe tiles for big wins',
    tag: 'Up to 100×+',
    color: '#F97316',
    bg: 'rgba(249,115,22,0.12)',
    border: 'rgba(249,115,22,0.3)',
  },
];

export function GamesHub({ onSelectGame }) {
  return (
    <div style={{ padding: '0 16px 16px' }}>
      <div className="page-header">
        <div className="page-header-icon purple" style={{ background: 'rgba(124,58,237,0.15)', border: '1px solid rgba(124,58,237,0.3)', borderRadius: 12, padding: '10px 12px' }}>🎮</div>
        <div>
          <div className="page-title">Games</div>
          <div className="page-subtitle">Play & Win LILAPE Points</div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8 }}>
        {GAMES.map(g => (
          <div
            key={g.id}
            onClick={() => onSelectGame(g.id)}
            style={{
              background: g.bg,
              border: `1px solid ${g.border}`,
              borderRadius: 20,
              padding: '20px 18px',
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              cursor: 'pointer',
              transition: 'transform 0.15s, box-shadow 0.15s',
              WebkitTapHighlightColor: 'transparent',
            }}
            onTouchStart={e => e.currentTarget.style.transform = 'scale(0.97)'}
            onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <div style={{ fontSize: 44, lineHeight: 1, flexShrink: 0 }}>{g.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 800, fontSize: 18, color: '#fff', marginBottom: 4 }}>{g.title}</div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8, lineHeight: 1.4 }}>{g.desc}</div>
              <span style={{
                display: 'inline-block',
                padding: '3px 10px',
                borderRadius: 50,
                background: `${g.color}22`,
                border: `1px solid ${g.color}55`,
                color: g.color,
                fontSize: 11,
                fontWeight: 700,
              }}>{g.tag}</span>
            </div>
            <div style={{ color: g.color, fontSize: 22, flexShrink: 0 }}>›</div>
          </div>
        ))}
      </div>

      {/* Coming soon */}
      <div style={{ marginTop: 20, padding: 18, borderRadius: 16, background: 'rgba(255,255,255,0.02)', border: '1px dashed rgba(255,255,255,0.1)', textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 6 }}>🎰</div>
        <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-secondary)', marginBottom: 4 }}>More games coming soon</div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Wheel of Fortune · Blackjack · Poker</div>
      </div>
    </div>
  );
}
